import { useCallback, useEffect, useState } from 'react'
import { Order } from '../models/orders'
import fetchFarmerOrders from '../apis/fetchFarmerOrders'

const useFarmerOrders = (
  farmerId: string,
  startDate?: string,
  endDate?: string,
  searchQuesry?: string,
  orderType?: string,
) => {
  const [orders, setOrders] = useState<Order[]>([])
  const [loading, setLoading] = useState(false)
  const [loadingNext, setLoadingNext] = useState(false)
  const [page, setPage] = useState(1)
  const [hasNext, setHasNext] = useState(false)

  const fetchNext = async () => {
    if (hasNext && !loadingNext) {
      try {
        setLoadingNext(true)
        const response = await fetchFarmerOrders({
          farmerId,
          page,
          start_date: startDate,
          end_date: endDate,
          search_query: searchQuesry,
          order_type: orderType,
        })
        if (response) {
          setOrders(prev => prev.concat(response.results))
          setPage(prev => prev + 1)
          setHasNext(response.next !== null)
        }
      } catch (e) {
        console.log('Error fetching next page data', e)
      } finally {
        setLoadingNext(false)
      }
    }
  }

  const getOrders = useCallback(async () => {
    setLoading(true)
    try {
      const response = await fetchFarmerOrders({
        farmerId,
        page,
        start_date: startDate,
        end_date: endDate,
        search_query: searchQuesry,
        order_type: orderType,
      })
      if (response) {
        setOrders(response.results)
        setPage(prev => prev + 1)
        setHasNext(!!response.next)
      }
    } catch (e) {
      console.log('Error in fetching orders', e)
    } finally {
      setLoading(false)
    }
  }, [endDate, farmerId, orderType, searchQuesry, startDate])

  useEffect(() => {
    getOrders()
  }, [getOrders])

  return {
    fetchNext,
    orders,
    loading,
    loadingNext,
  }
}

export default useFarmerOrders
